import "../StatusBadge.css";

const StatusBadge = ({ isClosed }) => {
  
  return (
    <span className={`status-badge ${isClosed ? "status-badge--closed" : "status-badge--open"}`}>
      <span className={`status-badge-dot${isClosed ? "__false" : ""}`} />
      {isClosed ? "Closed" : "Available"}
    </span>
  );
}

export default StatusBadge;
